import React, { Fragment } from 'react';

import { useTranslation } from 'react-i18next';

import StatisticsComponent from '../components/statistics/StatisticsComponent';

const Statistics = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <h1>{t('statistics.name')}</h1>
      <StatisticsComponent />
    </Fragment>
  );
};

export default Statistics;
